import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, shareReplay } from 'rxjs';
import { AUTH_CONFIG, type AuthConfig } from '../features/auth/auth.config';
import { APP_NAME } from '@olv/ui-shared/services/app-context.service';

export interface ExchangeCategory {
  id: number;
  label: string;
}

@Injectable({
  providedIn: 'root',
})
export class ExchangeCategoryService {
  private readonly cfg = inject<AuthConfig>(AUTH_CONFIG);
  private readonly http = inject(HttpClient);
  private readonly appName = inject(APP_NAME, { optional: true });
  private readonly url = `${this.cfg.baseUrl}/api/RiskCategories`;
  private categories$?: Observable<ExchangeCategory[]>;

  getExchangeCategories(): Observable<ExchangeCategory[]> {
    if (this.appName === 'merchant') {
      return of([]);
    }

    if (!this.categories$) {
      this.categories$ = this.http.get<ExchangeCategory[]>(this.url).pipe(
        catchError((error) => {
          console.error('Error loading exchange categories:', error);
          this.categories$ = undefined;
          return of([]);
        }),
        shareReplay(1),
      );
    }

    return this.categories$;
  }
}
